// ─────────────────────────────────────────────────────────────────────────────
// WHAT THE COVERAGE SEARCH SAYS FOR EACH ANSWER.
//
// 🔑 FOUR ANSWERS, NOT THREE. The endpoint returns eligible · not eligible ·
// not served (with a licence standing) · couldn't check. The fourth used to be
// collapsed into the third: Florida (application pending) and Georgia (nothing
// filed) both came back identical, which are materially different positions.
//
// 🚨 NO STRING HERE CARRIES A DATE, AND THAT IS ENFORCED.
// Saying "coming soon" — or "Q4 2026" — about a state where Doorly holds no
// licence is a representation about a regulator's timetable Doorly does not
// control. It is the same class of claim as the 392 Florida ZIPs that told
// borrowers Doorly served them for six months.
//
// The Florida target date EXISTS and is deliberately admin-only: Partner
// Success relays it in a conversation where they can caveat it, which a
// published string cannot. backend/test/serviceArea.test.js bans dates in these
// strings outright — phrases AND quarters, months, years and windows — so
// adding one is an argument somebody makes rather than a string somebody edits.
// ─────────────────────────────────────────────────────────────────────────────

export const SERVICE_AREA_COPY = {
  eligible:
    "In footprint. Bring it to us, and we'll confirm the specific property once you have an address.",

  not_eligible:
    "Not in our footprint. We lend in non-rural Texas counties, and this county is on the CFPB's published rural list.",

  // 🚨 THE ONLY STRING THAT REFERS TO A LICENCE NOT YET HELD, and it carries NO
  // DATE. "We're working on licensure" states what is true; a quarter or a year
  // would be a claim about a regulator's timetable Doorly does not control.
  //
  // ⚠️ THE Q4 2026 TARGET EXISTS AND IS DELIBERATELY NOT HERE. It lives on the
  // DoorlyDesk view only, so Partner Success can relay it in a conversation
  // where they can caveat it. A published date cannot be caveated. See
  // docs/service-area.md, and the date guard in
  // backend/test/serviceArea.test.js that stops one being added by edit.
  state_pending:
    "Florida isn't open yet. We're working on licensure — check with us before you refer.",

  state_waiting:
    'Not a state we serve. Texas is our footprint today.',

  // ⚠️ DOES NOT BLOCK. The reference data omits PO-box-only ZIPs, so this is a
  // gap on our side and never evidence about the property.
  unconfirmable:
    "We couldn't confirm this one automatically. Send it over and we'll check it by hand.",

  unreachable:
    "We couldn't check this right now. Try again in a moment.",
};

/** Which line an endpoint answer maps to. One place, so the two surfaces agree. */
export function copyFor(answer) {
  if (!answer) return SERVICE_AREA_COPY.unreachable;
  if (answer.confirmable === false) {
    return answer.reason === 'lookup_unavailable'
      ? SERVICE_AREA_COPY.unreachable
      : SERVICE_AREA_COPY.unconfirmable;
  }
  if (answer.eligible) return SERVICE_AREA_COPY.eligible;
  if (answer.reason === 'state_not_served') {
    return answer.standing === 'pending'
      ? SERVICE_AREA_COPY.state_pending
      : SERVICE_AREA_COPY.state_waiting;
  }
  return SERVICE_AREA_COPY.not_eligible;
}
